import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

const fields = (p) => ({ name: p.name, price: p.price ?? "", sale_mode: p.sale_mode || "priced", unit: p.unit, description: p.description || "", tag: p.tag || "", category: p.category });
const errorText = (e, fallback) => typeof e.response?.data?.detail === "string" ? e.response.data.detail : fallback;
export const useProductEditor = (product, onChange) => {
  const [draft, setDraft] = useState(null), [saving, setSaving] = useState(false), [uploading, setUploading] = useState(false);
  const form = draft || fields(product);
  const set = (key) => (event) => setDraft((old) => ({ ...(old || fields(product)), [key]: event.target.value }));
  const dirty = JSON.stringify(form) !== JSON.stringify(fields(product));
  const save = async () => {
    setSaving(true);
    try { const { data } = await axios.patch(`${API}/admin/products/${product.id}`, { ...form, price: form.sale_mode === "enquiry" ? null : Number(form.price) }); onChange(data); setDraft(null); toast.success("Product saved"); }
    catch (err) { toast.error(errorText(err, "Save failed")); }
    finally { setSaving(false); }
  };
  const toggle = async () => {
    try { const { data } = await axios.patch(`${API}/admin/products/${product.id}`, { is_active: product.is_active === false }); onChange(data); toast.success(data.is_active === false ? "Hidden from shop" : "Visible in shop"); }
    catch { toast.error("Update failed"); }
  };
  const upload = async (file) => {
    setUploading(true); const body = new FormData(); body.append("file", file);
    try { const { data } = await axios.post(`${API}/admin/products/${product.id}/image`, body); onChange(data); toast.success("Photo updated"); }
    catch (err) { toast.error(errorText(err, "Upload failed")); }
    finally { setUploading(false); }
  };
  return { form, set, dirty, saving, uploading, save, toggle, upload };
};